var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error403"},[_vm._m(0),_c('div',{staticClass:"error403__bottom"},[_vm._v(" SATOSHI EYE © "+_vm._s(_vm.getFullYear)+" ALL RIGHTS RESERVED ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error403__wrapper"},[_c('p',{staticClass:"error403__message"},[_vm._v(" Your account has been expired. "),_c('br'),_vm._v(" Please contact support to continue your subscription ")])])
}]

export { render, staticRenderFns }